// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';
import {
  grid,
  gridTemplateRows,
  gridTemplateColumns,
} from '../../../helpers/gridHelpers';
import {
  Title,
  SubTitle,
  PriceContainer,
} from '../components';

export const RowContainer = styled<any, Theme>('article')`
  /* Disable no-duplicate-selectors because stylelint interprets 'Dollar'{Title} as a div */
  /* stylelint-disable no-duplicate-selectors */
  ${grid()}
  ${gridTemplateRows('auto 3rem 2rem auto')}
  ${gridTemplateColumns('15rem 1fr 10rem')}
  column-gap: 1rem;

  picture {
    grid-area: 1 / 1 / 6 / 2;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 14.5rem;
    }
  }
  ${/* sc-sel */Title} {
    grid-area: 2 / 2 / 3 / 3;
  }
  ${/* sc-sel */SubTitle} {
    grid-area: 1 / 2 / 2 / 3;
  }
  ${/* sc-sel */PriceContainer} {
    grid-area: 1 / 3 / 3 / 4;
  }
`;
export default null;
